module.exports = __webpack_public_path__ + "assets/img/no_active_4.959315d1.svg";